import './card.scss'

import React from 'react'
import { GridContainer, GridItem } from '@entur/grid'
import { Heading4, SubParagraph } from '@entur/typography'
import { SmallAlertBox } from '@entur/alert'
import { space } from '@entur/tokens'

type CardBannerProps = {
  text: string
}
export const CardBanner: React.FC<CardBannerProps> = ({ text }) => {
  return (
    <SmallAlertBox variant="warning" className="card-banner">
      <SubParagraph>{text}</SubParagraph>
    </SmallAlertBox>
  )
}

type CardGridProps = {
  header: React.ReactNode
  children: React.ReactNode
  useOwnGrid?: boolean
  className?: string
  top?: React.ReactNode
  iconButtons?: React.ReactNode
  spacing?: 'none' | 'extraSmall2' | 'extraSmall' | 'small' | 'medium' | 'large' | 'extraLarge'
}
const CardGrid: React.FC<CardGridProps> = ({
  header,
  children,
  className,
  useOwnGrid = false,
  top,
  iconButtons,
  spacing = 'none',
}) => {
  return (
    <GridContainer className={className} spacing={spacing}>
      {top && (
        <GridItem small={12} style={{ marginBottom: -space.small }}>
          {top}
        </GridItem>
      )}
      <GridItem small={11}>{header}</GridItem>
      <GridItem small={1}>{iconButtons}</GridItem>
      {useOwnGrid ? children : <GridItem small={12}>{children}</GridItem>}
    </GridContainer>
  )
}

type InfoCardProps = {
  header: React.ReactNode
  children: React.ReactNode
  useOwnGrid?: boolean
  iconButtons?: React.ReactNode
  top?: React.ReactNode
  spacing?: 'none' | 'extraSmall2' | 'extraSmall' | 'small' | 'medium' | 'large' | 'extraLarge'
  className?: string
  style?: React.CSSProperties
}
export const InfoCard: React.FC<InfoCardProps> = ({
  header,
  children,
  useOwnGrid = false,
  top,
  iconButtons,
  spacing,
  className,
  style,
}) => {
  return (
    <div className={`card info-card ${className}`} style={style}>
      <CardGrid header={header} useOwnGrid={useOwnGrid} iconButtons={iconButtons} spacing={spacing} top={top}>
        {children}
      </CardGrid>
    </div>
  )
}

type IconCardProps = {
  header: string
  children: React.ReactNode
  id?: string
  useOwnGrid?: boolean
  icon: React.ReactNode
  iconButtons: React.ReactNode
}
export const IconCard: React.FC<IconCardProps> = ({
  header,
  children,
  id,
  icon,
  iconButtons,
  useOwnGrid = false,
}) => {
  return (
    <div className="card icon-card" id={id}>
      <div style={{ display: 'flex', position: 'relative' }}>
        {icon}
        <CardGrid className="icon-card__info" header={<Heading4>{header}</Heading4>} useOwnGrid={useOwnGrid}>
          {children}
        </CardGrid>
        {iconButtons}
      </div>
    </div>
  )
}
